import Vue from 'vue';
import Router from 'vue-router';

const Login = () => import('@/views/Login.vue')
// const Register = () => import('@/views/Register.vue')
const ForgotPass = () => import('@/views/ForgotPass.vue')
const Logout = () => import('@/views/Logout.vue')
const Settings = () => import('@/views/Settings.vue')
const Products = () => import("@/views/Products.vue")
const Cart = () => import("@/views/Cart.vue")
const Checkout = () => import("@/views/Checkout.vue")

// Management

const ManagementProducts = () => import('@/views/management/Products.vue')
const Product = () => import('@/views//Product.vue')
const ManagementUsers = () => import('@/views/management/Users.vue')
const ManagementUser = () => import('@/views/management/User.vue')
const ManagementCategories = () => import('@/views/management/Categories.vue')
const ManagementCategory = () => import('@/views/management/Category.vue')
const ManagementStats = () => import('@/views/management/Stats.vue')
const ManagementGroups = () => import('@/views/management/Groups.vue')
const ManagementGroup = () => import('@/views/management/Group.vue')

const Privacy = () => import('@/views/Segments/footer/Privacy.vue')
const Imprint = () => import('@/views/Segments/footer/Imprint.vue')
const Contact = () => import('@/views/Segments/footer/Contact.vue')


Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: Register
  // },
  {
    path: '/forgotPass',
    name: 'ForgotPass',
    component: ForgotPass
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },

  {
    path: '/management/products',
    name: 'ManagementProducts',
    component: ManagementProducts
  },
  {
    path: '/management/user/:id',
    name: 'ManagementUser',
    component: ManagementUser
  },
  {
    path: '/management/users',
    name: 'ManagementUsers',
    component: ManagementUsers
  },
  {
    path: '/management/categories',
    name: 'ManagementCategories',
    component: ManagementCategories
  },
  {
    path: '/management/category/:id',
    name: 'ManagementCategory',
    component: ManagementCategory
  },
  {
    path: '/management/stats',
    name: 'ManagementStats',
    component: ManagementStats
  },
  {
    path: '/management/groups',
    name: 'ManagementGroups',
    component: ManagementGroups
  },
  {
    path: '/management/group/:id',
    name: 'ManagementGroup',
    component: ManagementGroup
  },


  


  {
    path: '/cart',
    name: 'Cart',
    component: Cart
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout
  },
  {
    path: '/products',
    alias: ["/"],
    name: "Products",
    component: Products
  },
  {
    path: '/product/:id',
    name: 'Product',
    component: Product
  },
  {
    path: '/footer/imprint',
    name: 'Imprint',
    component: Imprint
  },
  {
    path: '/footer/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/footer/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
]
});

export default router
